import client from '../client';
import * as cargoMutations from "../mutations/cargo";
import * as cargoQueries from "../queries/cargo";



export function getCargoes(success, error, fogId, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { fogId: fogId },
        fetchPolicy: fetchPolicy,
        query: cargoQueries.all,
    })
        .then(success)
        .catch(error);
}


export function get(success, error, id, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { id: id },
        fetchPolicy: fetchPolicy,
        query: cargoQueries.get,
    })
        .then(success)
        .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { cargo: data },
        mutation: cargoMutations.add,
    }).then(success).catch(error);;
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, cargo: data },
        mutation: cargoMutations.edit,
    }).then(success).catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/cargo.js